// extracted by mini-css-extract-plugin
module.exports = {"Modal":"_1dtUqkCh","closeButton":"rtHMCBQK","closeIcon":"_1HU8ezzV","appear":"_3VHv0B3E","appearActive":"VTwKbikg","nextButton":"_3r6Mhx3x","prevButton":"_1RewjEHl","navElementContainer":"_1llscPrT","pageButtons":"_32iH_XZc","disabledNavButton":"miUe7cy1"};
    if(module.hot) {
      // 1754514980122
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  